import { useState, useEffect } from 'react';
import { useMutation, gql } from '@apollo/client';
import { useNavigate } from 'react-router';
import {
  Input,
  Box,
  Button,
  FormControl,
  FormLabel,
  Typography,
  Stack,
  FormHelperText,
} from '@mui/joy';
import { parseGraphQLError } from '../../utils';
import { useFeedback } from '../feedback/Service';


const RESET_PASSWORD = gql`
  mutation ResetPassword($token: String!, $password: String!) {
    resetPassword(token: $token, password: $password)
  }
`;

export default function ResetPassword() {
  const [resetPassword, { loading }] = useMutation(RESET_PASSWORD);
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const feedback = useFeedback();
  const navigate = useNavigate();

  const handleSubmit = async event => {
    event.preventDefault();
    // const formData = new FormData(event.currentTarget);
    try {
      const res = await resetPassword(({ variables: { token: window.location.hash.substring(1), password } }));
      console.log(res);
      feedback.snackbar({ text: "Password set", type: "success" });
      navigate("/sign-in");

    } catch (error) {
      console.error("Reset password error", error);
      feedback.snackbar({ text: parseGraphQLError(error), type: "error" });
    }
  };

  useEffect(() => {
    if (!window.location.hash)
      navigate("/");
  }, [navigate]);

  return (
    <Box
      component="main"
      sx={{
        my: 'auto',
        py: 2,
        pb: 5,
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
        width: 400,
        maxWidth: '100%',
        mx: 'auto',
        borderRadius: 'sm',
        '& form': {
          display: 'flex',
          flexDirection: 'column',
          gap: 2,
        },
        [`& .MuiFormLabel-asterisk`]: {
          visibility: 'hidden',
        },
      }}
    >
      <Stack sx={{ gap: 4, mb: 2 }}>
        <Stack sx={{ gap: 1 }}>
          <Typography component="h1" level="h3">
            Reset Password
          </Typography>
        </Stack>
      </Stack>
      <Stack sx={{ gap: 4, mt: 2 }}>
        <form
          onSubmit={handleSubmit}
        >
          <FormControl required>
            <FormLabel>New Password</FormLabel>
            <Input
              autoComplete="new-password"
              value={password}
              onChange={({ target: { value } }) => setPassword(value)}
              type='password'
            />
            <FormHelperText>Password must be at least 6 characters long</FormHelperText>
          </FormControl>
          <FormControl required>
            <FormLabel>Confirm Password</FormLabel>
            <Input
              autoComplete="new-password"
              value={confirmPassword}
              onChange={({ target: { value } }) => setConfirmPassword(value)}
              type='password'
            />
          </FormControl>
          <Stack sx={{ gap: 4, mt: 2 }}>
            <Button type="submit" fullWidth loading={loading} disabled={password !== confirmPassword}>
              Submit
            </Button>
          </Stack>
        </form>
      </Stack>
    </Box>
  );
}